import { useState } from 'react';

const faqs = [
  {
    q: 'Who provides commercial construction services near me in Henry County, GA?',
    a: 'Fletcher & Cooley, Inc. is a locally based, licensed Georgia general contractor serving Henry County, Stockbridge, McDonough, Hampton, Locust Grove, and surrounding Metro Atlanta communities. We specialize in commercial build-outs and tenant improvements for businesses of all sizes.',
  },
  {
    q: 'How much does a commercial build-out cost in Henry County?',
    a: 'Commercial build-out costs vary based on square footage, scope of work, finish level, and trade requirements. Most commercial projects in Henry County range from $40 to $150+ per square foot. We provide detailed, itemized estimates after a site evaluation — no guesswork, no surprises.',
  },
  {
    q: 'How long does a commercial build-out take?',
    a: 'Timelines depend on project size and complexity. A standard tenant improvement typically takes 6–12 weeks from permit approval to final inspection. Larger or more complex builds may take 3–6 months. We provide a structured schedule at project kickoff so you can plan your opening with confidence.',
  },
  {
    q: 'Do you handle permitting for commercial construction in Henry County?',
    a: 'Yes. We manage the entire permitting process — from plan submission to inspection scheduling — with Henry County building departments. Our local experience means fewer delays and faster approvals compared to contractors unfamiliar with the local process.',
  },
  {
    q: 'Can you work with franchise brands and corporate construction standards?',
    a: 'Absolutely. We have extensive experience working with franchise operators and corporate real estate teams. We understand brand standards, prototype drawings, and the documentation requirements that come with franchise build-outs — and we deliver to spec every time.',
  },
  {
    q: 'Are you licensed and insured in Georgia?',
    a: 'Yes. Fletcher & Cooley, Inc. is a fully licensed and insured general contractor in the state of Georgia. We carry all required liability and workers\' compensation coverage, and we can provide certificates of insurance upon request.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-amber-600" />
            <span className="text-amber-700 text-xs font-semibold tracking-[0.2em] uppercase">
              FAQ
            </span>
            <div className="w-8 h-px bg-amber-600" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Frequently Asked Questions
          </h2>
          <p className="text-stone-500 mt-4 text-base max-w-xl mx-auto leading-relaxed">
            Direct answers to the questions we hear most from commercial property owners and business operators in Henry County.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-stone-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-stone-50 transition-colors duration-200 cursor-pointer"
              >
                <span className="font-semibold text-stone-900 text-sm pr-4">{faq.q}</span>
                <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
                  <i
                    className={`text-amber-700 text-lg transition-transform duration-300 ${
                      open === i ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  />
                </span>
              </button>
              {open === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
